import { Component, OnInit, HostListener, HostBinding, OnDestroy } from '@angular/core';
import { BnNgIdleService } from 'bn-ng-idle';
import { CommonService } from './middleware/common/common.service';
import { MatDialogConfig, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { LogoutDialogComponent } from './middleware/shared/dialogueBoxes/logout/logout-dialog.component';
import { Constants } from './middleware/common/reusableclassesAndFunctions/constants';
import { ThemingService } from './theming.service';
import { OverlayContainer } from '@angular/cdk/overlay';
import { Subscription } from 'rxjs';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { UserActivationDialogComponent } from './middleware/shared/dialogueBoxes/useractivation/useractivation-dialog.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'ECM';
  count: number = 0;
  isButtonPressed: boolean = false;

  themingSubscription: Subscription;

  showChat:boolean = false;
  showChatWindow = false;
  showWrapper: boolean = false;
  Email:string="";
  Token:string="";
  UserActivationEmail:string="";
  UserActivationToken:string="";

  getChatOpen(message:boolean){
    this.showChat = message;
  }
  getChatclose(message:boolean){
    this.showChat = message;
  }
  getopenChatWindow(message:boolean){
    this.showChatWindow = message;
  }

  @HostListener('window:unload', ['$event'])
  unloadHandler(event) {
  // your code
  // this.commonService.logoutUser();
  }
  
  @HostListener('window:beforeunload', ['$event'])
  beforeunloadHandler(event) {
    let isRefresh = sessionStorage.getItem('isRefresh');
    if (isRefresh !== 'false') {
      this.commonService.logoutUser();
    }
  }

  constructor(private bnIdle: BnNgIdleService, private commonService: CommonService,
    private matDialog: MatDialog, public dialogRef: MatDialogRef<LogoutDialogComponent>,
    private constant: Constants,private router: Router,
    private themingService: ThemingService,private route: ActivatedRoute,
    private overlayContainer: OverlayContainer) {
      this.showWrapper = false
      const encryptedtoken = sessionStorage.getItem('userToken');
      if (encryptedtoken != null && encryptedtoken != undefined) {
        this.showWrapper = true;
      }
      else{
        this.showWrapper = false
      }
     

    this.bnIdle.startWatching(constant.logoutNotificationTime).subscribe((res: boolean) => {
      if (res) {
        let currentUser = sessionStorage.getItem('userToken');
        if (currentUser != null && currentUser != undefined && currentUser != "") {
           if(this.showWrapper == true){
            sessionStorage.clear();
            this.matDialog.closeAll();
            this.router.navigate(['/auth/login']);
            // let counts = sessionStorage.getItem('count');
            //  if (counts != '1') {               
            //  // this.openDialog();
            //  // this.isIdleTimeExpired();
            //  }else{
            //  // sessionStorage.clear();
            //  // this.router.navigate(['/auth/login']);
            //  }
           } 
          // if( this.showWrapper == true){
          //   if (this.count < 1) {
          //     this.openDialog();
          //     this.isIdleTimeExpired();
          //   }  
          // }                 
        }
      }
    })
     this.getQueryParameter();    
  }

    

  getQueryParameter() {
    this.route.queryParams.subscribe(params => {
      this.Email = params['Email'];
      this.Token = params['Token'];
      if(this.Email!=undefined && this.Token!=undefined){
        let currentUser = sessionStorage.getItem('userToken');
        if (currentUser != null && currentUser != undefined && currentUser != "") {
          this.UserActivationEmail=this.Email;
          this.UserActivationToken=this.Token;
          sessionStorage.setItem("UserActivationEmail",this.UserActivationEmail);
          sessionStorage.setItem("UserActivationToken",this.UserActivationToken);
          // this.router.navigate(['/request/alreadyLogin']);         
         // this.openDialogUserActivation();
        }       
      }
    });
  }

  @HostBinding('class') public cssClass: string;

  
  ngOnInit() {
    this.themingSubscription = this.themingService.theme.subscribe((theme: string) => {
      this.cssClass = theme;
      this.applyThemeOnOverlays();
    });
    this.showWrapper=false;
    this.router.events.subscribe(event=>{
      if(event instanceof NavigationEnd){
        if(event.url.includes('/request/signature')){
         this.showWrapper=false;
        }
        else if(event.url.includes('/request/HtmlFormSign')){
          this.showWrapper=false;
         }
        else if(event.url.includes('/request/tabularsignature')){
          this.showWrapper=false;
         }
        else if(event.url.includes('/auth/login')){
          this.showWrapper=false;
         }
         else if(event.url.includes('/request/thanks')){
          this.showWrapper=false;
         }
         else if(event.url.includes('/request/declineurl')){
          this.showWrapper=false;
         }
         else if(event.url.includes('/request/htmlthanks')){
          this.showWrapper=false;
         }
         else if(event.url.includes('/request/fileManagerthanks')){
          this.showWrapper=false;
         }
         else if(event.url.includes('/request/alreadyLogin')){
          this.showWrapper=false;
         }
         else if(event.url.includes('/request/ordetail')){
          this.showWrapper=false;
         }
         else if(event.url.includes('/request/documents')){
          this.showWrapper=false;
         }
         else if(event.url.includes('/request/fileManagerdocuments')){
          this.showWrapper=false;
         }
         else if(event.url.includes('/request/fileManagerviewer')){
          this.showWrapper=false;
         }         
         else if(event.url.includes('/request/projectFromFormLink')){
          this.showWrapper=false;
         }
         else if(event.url.includes('/auth/forgotPassword')){
          this.showWrapper=false;
         }
         else if(event.url.includes('/auth/updatePassword')){
          this.showWrapper=false;
         }
         else if(event.url.includes('/auth/UserRegistrationInvite')){
          this.showWrapper=false;
         }
         else if(event.url.includes('/request/task')){
          this.showWrapper=false;
         }
         else if(event.url.includes('/request/tickettask')){
          this.showWrapper=false;
         }
         else if(event.url.includes('/request/thanksTicket')){
          this.showWrapper=false;
         }
         else if(event.url.includes('/dashboard')){
          this.showWrapper=true;
         }
         else if(event.url.includes('/all')){
          this.showWrapper=true;
         }
         else if(event.url.includes('/request/projectdeleted')){
          this.showWrapper=false;
         }
         else if(event.url.includes('/request/portal')){
          this.showWrapper=false;
         }
         else if(event.url.includes('/auth/portallogin')){
          this.showWrapper=false;
         }
         else if(event.url.includes('/auth/verifyip')){
          this.showWrapper=false;
         }  
         else if(event.url.includes('/request/formfolderurl')){
          this.showWrapper=false;
         }  
         else if(event.url.includes('/request/thanksassigntosomeone')){
          this.showWrapper=false;
         }   
         else if(event.url.includes('/request/portalsignature')){
          this.showWrapper=false;
         }   
         else if(event.url.includes('/request/portalpdfupload')){
          this.showWrapper=false;
         }   
         else if(event.url == '/'){
          this.showWrapper = false;
         }
        else{
          this.showWrapper = true;
        }        
      }
    })
  }

  
  private applyThemeOnOverlays() {
    // remove old theme class and add new theme class
    // we're removing any css class that contains '-theme' string but your theme classes can follow any pattern
    const overlayContainerClasses = this.overlayContainer.getContainerElement().classList;
    const themeClassesToRemove = Array.from(this.themingService.themes);
    if (themeClassesToRemove.length) {
      overlayContainerClasses.remove(...themeClassesToRemove);
    }
    overlayContainerClasses.add(this.cssClass);
  }

  ngOnDestroy() {
    this.themingSubscription.unsubscribe();
  }

  // ngOnInit(): void {
    // logout if browser window is closed
  //   let self = this;
  //   window.addEventListener("beforeunload", function (e) {
  //     let currentUser = sessionStorage.getItem('userToken');
  //     if(currentUser){
  //         self.commonService.logoutUser();
  //     }
  // });
  // }


  //Summary
  //logout the user if user doesn't press Yes or No in popup after 10 sec.
  isIdleTimeExpired() {
    setTimeout(() => {
      if (!this.isButtonPressed) {
      //this.commonService.logoutUser();
      }
    },10000);
  }

   //Summary
  //Open dialogue box.
  openDialog() {
    this.count = this.count+ 1;    
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = false;
    let dialogRef = this.matDialog.open(LogoutDialogComponent, dialogConfig);
    let userChoice;
    dialogRef.afterClosed().subscribe(value => {     
      userChoice = value
      if (userChoice == 'Y') {
        sessionStorage.setItem('count', '1');
        this.isButtonPressed = true;
        this.commonService.refreshToken();
      }
      else {
        this.isButtonPressed = true;
        this.commonService.logoutUser();       
      }
    });
  }

   //Summary
  //Open dialogue box.
  openDialogUserActivation() {   
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = false;
    let dialogRef = this.matDialog.open(UserActivationDialogComponent, dialogConfig);
    let userChoice;
    dialogRef.afterClosed().subscribe(value => {     
      userChoice = value
      if (userChoice == 'Y') {
        this.isButtonPressed = true;
        this.commonService.refreshToken();
      }
      else {
        sessionStorage.setItem("UserActivationEmail",this.UserActivationEmail);
        sessionStorage.setItem("UserActivationToken",this.UserActivationToken);
        this.isButtonPressed = true;
        this.commonService.logoutUser();       
      }
    });
  }
}
